/**
 * @generated SignedSource<<cb09ab4d2b8691cb4abd386cbd035271>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkatoIntegration = "HiBob" | "%future added value";
export type StartRecipesInput = {
  integration?: WorkatoIntegration | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type startRecipesMutation$variables = {
  input: StartRecipesInput;
};
export type startRecipesMutation$data = {
  readonly startRecipes: {
    readonly outcome: string | null;
  } | null;
};
export type startRecipesMutation = {
  variables: startRecipesMutation$variables;
  response: startRecipesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartRecipesPayload",
    "kind": "LinkedField",
    "name": "startRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "startRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "startRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0767b435769f329a6b7c1b5287bebd99",
    "id": null,
    "metadata": {},
    "name": "startRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation startRecipesMutation(\n  $input: StartRecipesInput!\n) {\n  startRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc07ad06f753abc5879ba3fc55608528";

export default node;
